import { ssoAuthService } from '@/services'
import { SHARED_LOADING, SHARED_UNLOADING } from "@/store/shared.module";

//define module name
const MODULE_NAME = 'ssoAuth/'

//define actions name
const A_TELEGRAM_LOGIN = 'telegramLogin'
const A_TELEGRAM_CONFIG = 'telegramConfig'
const A_TELEGRAM_VERIFY = 'telegramVerify'
const A_SSO_REGISTER = 'ssoRegister'
const A_RESET_SSO_LOGIN = 'resetSsoLogin'
const A_RESET_SSO_REGISTER = 'resetSsoRegister'
const A_RESET_SSO_VERIFY_ERROR = 'resetSsoVerifyError'

//define dispatch action
export const TELEGRAM_LOGIN = MODULE_NAME + A_TELEGRAM_LOGIN
export const TELEGRAM_VERIFY = MODULE_NAME + A_TELEGRAM_VERIFY
export const TELEGRAM_CONFIG = MODULE_NAME + A_TELEGRAM_CONFIG
export const RESET_SSO_LOGIN = MODULE_NAME + A_RESET_SSO_LOGIN
export const RESET_SSO_REGISTER = MODULE_NAME + A_RESET_SSO_REGISTER
export const RESET_SSO_VERIFY_ERROR = MODULE_NAME + A_RESET_SSO_VERIFY_ERROR

//define mutations name
const M_TELEGRAM_CONFIG = 'setTelegramConfig'
const M_RESET_TELEGRAM_VERIFY = 'resetTelegramLogin'
const M_SSO_REGISTER = 'setSsoRegister'
const M_SSO_LOGIN = 'setSsoLogin'
const M_RESET_SSO_REGISTER  = 'resetSsoRegister'
const M_RESET_SSO_LOGIN = 'resetSsoLogin'
const M_SSO_VERIFY_ERROR = 'setSsoVerifyError'
const M_RESET_SSO_VERIFY_ERROR = 'resetSsoVerifyError'

//init app state
const state = {
    telegramConfig: {
        botId: '',
        botName: '',
        iframeHost: '',
    },
    telegramVerifyResult: {
        complete: false,
        success: false,
        code: 0,
        data: []
    },
    // Trigger when success login/verified by SSO provider, but user not registered
    ssoRegisterData: {
        regType: -1,
        providerName: '',
        membercode: '',
        registerKey: '',
        time: new Date()
    },

    // Trigger when success login/verified by SSO provider, and user already registered
    ssoLoginData: {
        regType: -1,
        providerName: '',
        membercode: '',
        loginKey: '',
        time: new Date()
    },
    ssoVerifyError: {
        complete: false,
        status: false,
        data: {},
        error: ''
    }
}

//to retrieve data from store state (called by component)
const getters = {}

//to perform some actions related with updating state (called by component)
const actions = {
    [A_TELEGRAM_LOGIN]({ commit, dispatch ,state }) {

    },
    [A_TELEGRAM_CONFIG]({ commit }) {
        ssoAuthService.getTelegramConfig().then(
            result => {
                commit(M_TELEGRAM_CONFIG, { result })
            },
            error => {
                commit(M_TELEGRAM_CONFIG, { result: error })
            }
        )
    },
    [A_TELEGRAM_VERIFY]({ dispatch, commit }, { telegramUser }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        ssoAuthService
            .telegramVerify(telegramUser)
            .then(
                res => {
                    dispatch(`${SHARED_UNLOADING}`, {}, { root: true })

                    if (res.data.register_key) {
                        // Handle new telegram user registration
                        commit(M_SSO_REGISTER, { data: res })
                    } else if (res.data.login_key) {
                        commit(M_SSO_LOGIN, { data: res })
                    }
                },
                error => {
                    dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                    let result = error
                    commit(M_SSO_VERIFY_ERROR, { result })
                }
            )
    },
    [A_SSO_REGISTER]({ commit }, { data }) {
        commit(`${M_SSO_REGISTER}`, { data })
    },
    [A_RESET_SSO_LOGIN]({ commit }) {
        commit(`${M_RESET_SSO_LOGIN}`)
    },
    [A_RESET_SSO_REGISTER]({ commit }) {
        commit(`${M_RESET_SSO_REGISTER}`)
    },
    [A_RESET_SSO_VERIFY_ERROR]({ commit }) {
        commit(`${M_RESET_SSO_VERIFY_ERROR}`)
    },
}

//to update state values (called by actions)
const mutations = {
    [M_TELEGRAM_CONFIG](state, { result }) {
        if (result.success && result.data) {
            state.telegramConfig.botId = result.data.bot_id || ''
            state.telegramConfig.botName = result.data.bot_name || ''
            state.telegramConfig.iframeHost = result.data.iframe_host || ''
        } else {
            state.telegramConfig.botId = ''
            state.telegramConfig.botName = ''
            state.telegramConfig.iframeHost = ''
        }
    },
    [M_RESET_TELEGRAM_VERIFY](state) {
        state.telegramVerifyResult = {
            complete: false,
            success: false,
            code: 0,
            data: []
        }
    },
    [M_SSO_REGISTER](state, { data }) {
        const d = data.data || {}
        state.ssoRegisterData = {
            membercode: d.membercode || '',
            regType: d.fk_reg_type || -1,
            providerName: d.provider_name || '',
            registerKey: d.register_key || '',
            time: new Date()
        }
    },
    [M_SSO_LOGIN](state, { data }) {
        const d = data.data || {}
        state.ssoLoginData = {
            membercode: d.membercode || '',
            regType: d.fk_reg_type || -1,
            providerName: d.provider_name || '',
            loginKey: d.login_key || '',
            time: new Date()
        }
    },
    [M_RESET_SSO_LOGIN](state) {
        state.ssoLoginData = {
            membercode: '',
            regType: -1,
            providerName: '',
            loginKey: '',
            time: new Date()
        }
    },
    [M_RESET_SSO_REGISTER](state) {
        state.ssoRegisterData = {
            membercode: '',
            regType: -1,
            providerName: '',
            registerKey: '',
            time: new Date()
        }
    },
    [M_SSO_VERIFY_ERROR](state, { result }) {
        state.ssoVerifyError = {
            complete: true,
            success: result.success,
            data: result.data || {},
            error: result.error || ''
        }
    },
    [M_RESET_SSO_VERIFY_ERROR](state) {
        state.ssoVerifyError = {
            complete: false,
            success: false,
            data: {},
            error: ''
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
